import { useEffect } from 'react'
import * as S from './styles'
import useAuth from 'hooks/useAuth'
import config from 'config'

type MenuStepProps = {
  avancar: number
  material?: boolean
  plantaTecnica?: boolean
  cloneConsultoria?: boolean
}
const MenuStep = ({
  avancar,
  material,
  plantaTecnica,
  cloneConsultoria
}: MenuStepProps) => {
  const { usuario } = useAuth()

  function teste() {
    const li = document.querySelectorAll('.vcv-timeline-item')
    const span = document.querySelectorAll('.bol-Number')
    const title = document.querySelectorAll('.pTitle')
    if (usuario?.perfil != config.PERFIL_EXTERNO) {
      switch (avancar) {
        case 1:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          break
        case 2:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          break
        case 3:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          break
        case 4:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          break
        case 5:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          break

        case 6:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          break
        case 7:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          break
        case 8:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          li[4].classList.add('vcv-step-done')
          span[4].classList.add('ativo')
          title[4].classList.add('ativo')
          break
        case 9:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          li[4].classList.add('vcv-step-done')
          span[4].classList.add('ativo')
          title[4].classList.add('ativo')
          break
        case 10:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          li[4].classList.add('vcv-step-done')
          span[4].classList.add('ativo')
          title[4].classList.add('ativo')
          break
      }
    } else {
      switch (avancar) {
        case 1:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          break
        case 2:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          break
        case 3:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          break
        case 4:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          break
        case 5:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          break
        case 6:
          li[0].classList.add('vcv-step-done')
          span[0].classList.add('ativo')
          title[0].classList.add('ativo')
          li[1].classList.add('vcv-step-done')
          span[1].classList.add('ativo')
          title[1].classList.add('ativo')
          li[2].classList.add('vcv-step-done')
          span[2].classList.add('ativo')
          title[2].classList.add('ativo')
          li[3].classList.add('vcv-step-done')
          span[3].classList.add('ativo')
          title[3].classList.add('ativo')
          break
      }
    }
  }

  useEffect(() => {
    teste()
  }, [avancar])
  return (
    <S.Wrapper>
      {usuario?.perfil != config.PERFIL_EXTERNO ? (
        <>
          <>
            {material ? (
              <ul className="vcv-timeline">
                <li className={`vcv-timeline-item `}>
                  <span className={`bol-Number`}>1</span>
                  <p className="pTitle">Plantas e Uploads</p>
                </li>
                <li className={`vcv-timeline-item `}>
                  <span className={`bol-Number`}>2</span>
                  <p className="pTitle">Pré-agendamento</p>
                </li>
              </ul>
            ) : (
              <>
                {plantaTecnica ? (
                  <ul className="vcv-timeline">
                    <li className={`vcv-timeline-item `}>
                      <span className={`bol-Number`}>1</span>
                      <p className="pTitle">Plantas Técnica</p>
                    </li>
                  </ul>
                ) : (
                  <>
                    {cloneConsultoria ? (
                      <ul className="vcv-timeline">
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>1</span>
                          <p className="pTitle">Selecione o ambiente</p>
                        </li>
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>2</span>
                          <p className="pTitle">Pré-agendamento</p>
                        </li>
                      </ul>
                    ) : (
                      <ul className="vcv-timeline">
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>1</span>
                          <p className="pTitle">Plantas e Uploads</p>
                        </li>
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>2</span>
                          <p className="pTitle">Pré-agendamento</p>
                        </li>
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>3</span>
                          <p className="pTitle">Ambientes e referências</p>
                        </li>
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>4</span>
                          <p className="pTitle">Cores Texturas e iluminação</p>
                        </li>
                        <li className={`vcv-timeline-item `}>
                          <span className={`bol-Number`}>5</span>
                          <p className="pTitle">Detalhes do ambiente</p>
                        </li>
                      </ul>
                    )}
                  </>
                )}
              </>
            )}
          </>
        </>
      ) : (
        <>
          <ul className="vcv-timeline">
            <li className={`vcv-timeline-item `}>
              <span className={`bol-Number`}>1</span>
              <p className="pTitle">Cadastro Cliente</p>
            </li>
            <li className={`vcv-timeline-item `}>
              <span className={`bol-Number`}>2</span>
              <p className="pTitle">Cadastro Parceiro</p>
            </li>
            <li className={`vcv-timeline-item `}>
              <span className={`bol-Number`}>3</span>
              <p className="pTitle">Configura Ambiente</p>
            </li>
            <li className={`vcv-timeline-item `}>
              <span className={`bol-Number`}>4</span>
              <p className="pTitle">Plantas e Uploads</p>
            </li>
          </ul>
        </>
      )}
    </S.Wrapper>
  )
}

export default MenuStep
